"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-32 bg-secondary-foreground/10 animate-pulse rounded" data-index={i} />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu viewport={false} className="block max-w-none">
      <NavigationMenuList className="flex-col items-start space-x-0 gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} className="w-full">
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group flex items-center text-sm text-secondary-foreground/70 hover:text-primary transition-colors w-full">
                <ArrowRight className="w-3 h-3 mr-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-primary" />
                <span className="group-hover:translate-x-1 transition-transform duration-300">
                  {item.label}
                </span>
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com"
  }, {
    icon: Instagram,
    href: "https://instagram.com"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com"
  }];
  const serviceAreas = ["Townsville & Suburbs", "North Queensland Region", "Charters Towers", "Burdekin Region", "Hinchinbrook Shire", "Magnetic Island", "Regional and remote areas"];
  return <footer id="footer" className="bg-secondary text-secondary-foreground pt-20 pb-10">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559587/img/image_98tojk0n.jpg" alt="ANV Painting Logo" className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-secondary-foreground/80 text-sm leading-relaxed max-w-xs">ANV Painting is a professional painting and decorating company serving residential and commercial clients throughout the North Queensland Region. We are dedicated to quality craftsmanship and lasting results..<br /><br />QBCC: 15409257</p>
            <div className="flex items-center gap-3 pt-2">
              {socialLinks.map((social, index) => <Link key={index} to={social.href} newTab className="group flex items-center justify-center w-10 h-10 rounded-full border border-secondary-foreground/20 bg-transparent transition-all duration-300 hover:bg-primary hover:border-primary hover:text-primary-foreground" aria-label="Social Link">
                  <social.icon className="w-5 h-5 transition-colors" />
                </Link>)}
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-primary">Quick Links</h3>
            <MenuProvider menu_id="18" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-primary">Contact Details</h3>
            <ul className="space-y-5">
              <li className="flex items-start gap-3 text-sm text-secondary-foreground/80 group">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5 group-hover:text-primary/80 transition-colors" />
                <span className="leading-snug">
                  Townsville, QLD,
                  <br />
                  North Queensland Region
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-secondary-foreground/80 group">
                <Phone className="w-5 h-5 text-primary shrink-0 group-hover:text-primary/80 transition-colors" />
                <Link to="tel:0712345678" className="hover:text-primary transition-colors">0409 908 999</Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-secondary-foreground/80 group">
                <Mail className="w-5 h-5 text-primary shrink-0 group-hover:text-primary/80 transition-colors" />
                <Link to="mailto:contact@anvpainting.com.au" className="hover:text-primary transition-colors">admin@anvpainting.com.au</Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-primary">Service Areas</h3>
            <ul className="grid grid-cols-1 gap-3">
              {serviceAreas.map((area, i) => <li key={i} className="flex items-center gap-2.5 text-sm text-secondary-foreground/70" data-index={i}>
                  <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                  {area}
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-secondary-foreground/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-secondary-foreground/50">
          <p>
            &copy; {currentYear} ANV Painting. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-primary transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>;
}